import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';
import { userStore } from '@big-direkt/state/user';
import { enableElfProdMode } from '@ngneat/elf';
import { syncState } from 'elf-sync-state';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import { environment } from './environments/environment';

if (environment.production) {
    enableProdMode();
    enableElfProdMode();
}

syncState(userStore);

bootstrapApplication(AppComponent, appConfig).catch(err => {
    // eslint-disable-next-line no-console
    console.error(err);
});
